<sync-listener></sync-listener>
<router-outlet></router-outlet>
<ngx-spinner [name]="DEFAULT_SPINNER" [size]="DEFAULT_SPINNER_SIZE" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)"
  color="#fff" type="timer">
  <p class="text-white text-center mt-20"> {{ spinnerText }} </p>
</ngx-spinner>